import React, { Component } from "react";
import { connect } from "react-redux";
import { findDOMNode } from "react-dom";
import { Input, Dropdown } from "semantic-ui-react";
import { UsStates, CanStates } from "../../state/hardDataset";

@connect(mapStateToProps)
export default class AddressForm extends Component {
  componentDidMount() {
    if (!this.props.disabled) {
      const addressInput = findDOMNode(this.addressInput).querySelectorAll(
        "input"
      )[0]; // The actual input is inside a div
      const countryCode =
        this.props.businessCountryCode.length > 0
          ? this.props.businessCountryCode.toLowerCase()
          : "us"; //default address selection to US if no country is set yet
      const options = { componentRestrictions: { country: countryCode } };

      if (window.google) {
        const autoComplete = new window.google.maps.places.Autocomplete(
          addressInput,
          options
        );
        autoComplete.addListener("place_changed", () => {
          const place = autoComplete.getPlace();
          let streetAddressValue = "";
          let cityValue = "";
          let stateValue = "";
          let postalCodeValue = "";
          for (let i = 0; i < place.address_components.length; i++) {
            let addressType = place.address_components[i].types[0];
            if (addressType === "street_number") {
              streetAddressValue = streetAddressValue.concat(
                place.address_components[i].long_name
              );
            } else if (addressType === "route") {
              if (streetAddressValue.length > 0) {
                streetAddressValue = streetAddressValue.concat(" ");
              }
              streetAddressValue = streetAddressValue.concat(
                place.address_components[i].long_name
              );
            } else if (
              addressType === "locality" ||
              addressType === "sublocality_level_1"
            ) {
              cityValue = place.address_components[i].long_name;
            } else if (addressType === "administrative_area_level_1") {
              stateValue = place.address_components[i].short_name;
            } else if (addressType === "postal_code") {
              postalCodeValue = place.address_components[i].long_name;
            }
          }
          this.props.addressChangeHandler(streetAddressValue);
          this.props.cityChangeHandler(cityValue);
          this.props.stateChangeHandler(stateValue);
          this.props.postalCodeChangeHandler(postalCodeValue);
        });
      }
    }
  }

  render() {
    let { AddressForm } = window.APP.LANGUAGE.Shared;
    let stateToDisplay = [];
    if (this.props.businessCountryCode.toLowerCase() === "us") {
      //just to safeguard against casing changes
      // use US states
      UsStates.map((state) => {
        stateToDisplay.push({
          key: state.abr,
          value: state.abr,
          text: state.abr,
        });
      });
    } else {
      // use canadian states
      CanStates.map((state) => {
        stateToDisplay.push({
          key: state.abr,
          value: state.abr,
          text: state.abr,
        });
      });
    }
    let elementToReturn = <div></div>;

    if (this.props.disabled) {
      elementToReturn = (
        <div className="address_row">
          <Input
            disabled
            autoComplete="off"
            name="booking_address1"
            placeholder={AddressForm.AddressPlaceholder}
            className="address1 booking_auto_complete"
          />
          <Input
            disabled
            autoComplete="off"
            name="booking_city"
            placeholder={AddressForm.CityPlaceholder}
            className="city booking_auto_complete"
          />
          <Dropdown
            disabled
            placeholder={AddressForm.StatePlaceholder}
            search
            selection
            compact
            options={stateToDisplay}
            className="state_dropdown"
          />
          <Input
            disabled
            autoComplete="off"
            name="booking_zipcode"
            placeholder={AddressForm.ZipPlaceholder}
            className="zipcode booking_auto_complete"
          />
        </div>
      );
    } else {
      elementToReturn = (
        <div className="address_row">
          <Input
            onChange={(event) => {
              this.props.addressChangeHandler(event.target.value);
            }}
            value={this.props.addressValue.address1}
            ref={(input) => {
              this.addressInput = input;
            }}
            autoComplete="off"
            name="booking_address1"
            placeholder={AddressForm.AddressPlaceholder}
            className="address1 booking_auto_complete"
          />
          <Input
            onChange={(event) =>
              this.props.cityChangeHandler(event.target.value)
            }
            value={this.props.addressValue.city}
            autoComplete="off"
            name="booking_city"
            placeholder={AddressForm.CityPlaceholder}
            className="city booking_auto_complete"
          />
          <Dropdown
            onChange={(param, data) =>
              this.props.stateChangeHandler(data.value)
            }
            value={this.props.addressValue.state}
            placeholder={AddressForm.StatePlaceholder}
            search
            selection
            compact
            options={stateToDisplay}
            className="state_dropdown"
          />
          <Input
            onChange={(event) =>
              this.props.postalCodeChangeHandler(event.target.value)
            }
            value={this.props.addressValue.postalcode}
            autoComplete="off"
            name="booking_zipcode"
            placeholder={AddressForm.ZipPlaceholder}
            className="zipcode booking_auto_complete"
          />
        </div>
      );
    }
    return elementToReturn;
  }
}

function mapStateToProps(state) {
  return {
    businessCountryCode: state.appointmentStepReducer.businessCountryCode,
  };
}
